import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import { ACCESS_TOKEN, USER_INFO, PANES_HISTORY_CACHE, IS_SELLERWELL } from '@/store/mutation-types'
import {
  findPane
} from '@/store/_util/util'
import {
  querySystemExtListForSub
} from '@/api/index'

NProgress.configure({
  showSpinner: false
})

function createEle () {
  const ele = document.createElement('div')
  ele.className = 'layout-loading-wrapper'
  ele.innerHTML = `
  <img src="/logo.png" style="width: 270px;">
  <div class="loading-wrp">
    <span class="dot dot-spin">
      <i></i>
      <i></i>
      <i></i>
      <i></i>
    </span>
  </div>
  <div class="loading-wrap__text">正在进入易仓系统，请耐心等候...</div>
  `
  return ele
}

const firstEle = createEle()

router.beforeEach(async (to, from, next) => {
  document.body.appendChild(firstEle)
  const { serviceId, systemCode } = to.params

  let ssoQuery = null
  if (/^\/#\//.test(to.fullPath)) {
    ssoQuery = (to.fullPath.split('?')?.[1] || '').split('&').reduce((acc, cur) => {
      const sp = cur.split('=')
      acc[sp[0]] = sp[1]
      return acc
    }, {})
    console.log('is sso: query:', ssoQuery)
  }
  const query = ssoQuery || to.query
  const { linkId, token, ...other } = query
  NProgress.start() // start progress bar
  // 特殊标识 清除token 防止token过期401重定向丢失window.opener
  if (to.path === '/login' && to.query.source === 'eccang') {
    Vue.ls.remove(ACCESS_TOKEN)
    Vue.ls.remove(USER_INFO)
  }
  // 根据路径参数实现自动登录 （ * token不一定是用户中心的那种）
  // e.g.
  // http://testnew-home.eccang.com/?token=ECC_57d64fa885ec496eb2d195ba8402a746&resouce=SELMUCH_ADS

  if (token) {
    window.localStorage.setItem('pro__Access-Token', token)
    store.dispatch('ClearDateAfterLogout')
    store.dispatch('AutoLogin', query)
      .then(() => {
        querySystemExtListForSub({
          paging: false,
          serviceCode: 'ERP+',
          fromFrontPage: true
        }).then(({ dataList }) => {
          const serviceInfoExt = dataList?.[0]?.serviceInfoExt || []
          const isExit = serviceInfoExt.find(item => item.systemCode === 'ERP' && item.serviceDeploy === 4)
          if (isExit) {
            const path = `/entry/${isExit.serviceId}/ERP/amazon#/setSail/index`
            next({ path, query: undefined })
          } else {
            next({ path: '/login' })
          }
        })
      })
      .catch(() => {
        next({ path: '/login' })
      })

      console.log('token', token)
      return
  }

  const accessToken = Vue.ls.get(ACCESS_TOKEN)
  const sUserAgent = navigator.userAgent.toLowerCase() // 浏览器用于 HTTP 请求的用户代理头的值
  const isMobile = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)
  // 跳转移动端注册
  if (isMobile && !/^#\/login/.test(to.hash)) {
    let url = process.env.NODE_ENV === 'production' ? '//m.sellerwell.com' : 'https://test-m.sellerwell.com'
    if (linkId || other.source || other.register) {
      const queryMoble = encodeURIComponent(`redirect=${to.fullPath}&linkId=${linkId}&serviceCode=${other.serviceCode}&inviteCode=${other.inviteCode}&source=${other.source}&register=${true}`)
      console.log('queryMoble', queryMoble)
      window.location.href = `${url}/m-sso/register?${queryMoble}`
      // const queryMoble = `redirect=${encodeURIComponent(to.fullPath)}&linkId=${ encodeURIComponent(linkId || '') }&serviceCode=${other.serviceCode || ''}&inviteCode=${other.inviteCode || ''}&source=${other.source || ''}&register=${true}`
      // window.location.href = `${url}login-register?${queryMoble}`
    } else {
      const queryString = query
        ? `?${Object.keys(query).map(key => `${key}=${query[key] || ''}`).join('&')}`
        : ''
      window.location.href = url + queryString
    }
    return
  }

  if (!accessToken) {
    // 亿数通需要的登录状态 * 刷新不重置
    localStorage.setItem('selmuch_status', true)
  }

  if (accessToken && to.path !== '/login') {
    const userId = store.getters.userInfo?.userId
    const userInfoResponse = await store.dispatch('GetUserInfo', { reset: !userId, serviceId })
    // 设置神策公共属性
    const options = {
      u_ty: '2', // 用户数据归属那个系统，1表示应用本身，2表示用户中心
      u_id: userInfoResponse.userCode, // 用户编码
      u_na: userInfoResponse.userRealName, // 用户真实名称
      com_code: userInfoResponse.subjectCodeEncrypt, // 公司代码
      ap_sou: 'USERCENTER',
      ap_na: '用户中心',
      ap_tk: accessToken,
      ap_ty: 'ERP-2',
      ap_vers: '', // 应用版本
      pre_link: 'is_null' // 上一页路由
    }
    if (to.hash) options.cu_link = to.hash
    if (from.hash) options.pre_link = from.hash
    Vue.$Shence.registerPage(options)
    // T: 首次进来
    if (!userId) {
      // 用户端环境（灰度）判断
      const ssoEnvList = userInfoResponse.ssoEnvList.reduce((acc, cur) => ({ ...acc, [cur.value]: cur.value }), {})
      const ssoEnvPath = ssoEnvList[userInfoResponse.ssoEnv]
      if (ssoEnvPath) {
        const curEnv = window.location.pathname.split('/')?.[1]
        if (curEnv !== ssoEnvPath && ssoEnvPath !== 'sso') {
          return (window.location = '/' + ssoEnvPath + to.fullPath)
        } else if (ssoEnvPath === 'sso' && process.env.SSO_ENV) {
          return (window.location = to.fullPath)
        }
      }
      // 用户基础配置API
      await Promise.all([
        store.dispatch('GetUserConfig'),
        store.dispatch('QuerySystemExtListForSub')
      ])
    }
    if (to.query.redirectPath) {
      const beeSystem = store.getters.systems.find(item => item.status === 2 && item.serviceDeploy === 4) || {}
      if (/^\/#\//.test(to.query.redirectPath)) {
        next(to.query.redirectPath)
      } else if (beeSystem) {
        next(`/entry/${beeSystem.serviceId}/${beeSystem.systemCode}${to.query.redirectPath}`)
      }
    }
  }
  // 更新路由前删除子系统标识类名
  const found = [...document.body.classList].find(cls => /^entry-view__/.test(cls))
  found && document.body.classList.remove(found)
  /**
   * 进入应用服务 - 注册子应用
   * 根据接口返回，判断进入正式环境 || 灰度环境
   */
  if (to.path.startsWith('/entry') && serviceId && systemCode && Vue.ls.get(ACCESS_TOKEN)) {
    // 判断当前子系统是否有进入权限
    const { status, serviceBillingValueDTOList, packageId } = store.getters.systems.find(item => item.systemCode === systemCode) || {}
    if (['ERP', 'AMAZON_OPERATE', 'BI'].includes(systemCode)) {
      const packageQuantity = (serviceBillingValueDTOList || [])?.find(item => item.keyValue === 'packageQuantity')
      const ERPPan = systemCode === 'ERP' && packageQuantity?.billingItemValue * 1 <= 0 && packageQuantity?.unlimitedUse !== 1
      if ((status === 4 || ERPPan) && !IS_SELLERWELL) {
        return next(`/401/${systemCode}`)
      }
    }
    if (([3, 9].includes(status) || !packageId)) {
      if (['Entry401', 'Entry402'].includes(to.name)) {
        return next(false)
      }
      return next(!packageId ? '/401' : `entry/${serviceId}/${systemCode}/402`)
    }
    if (to.params.name) {
      document.body.classList.add('entry-view__' + to.params.name)
    }
    if (serviceId !== from.params.serviceId || systemCode !== from.params.systemCode) {
      const { microApps, pageTypeId } = await store.dispatch('InitMicroAppsEntry', { serviceId, systemCode })
      const homePath = await store.dispatch('entry/GenerateMenus', { serviceId, systemCode, microApps, pageTypeId })
      // console.log('homePath', homePath, to.path)
      // 如果是ECCANG官方应用，比如shopify运营应用，是新页面打开ERP系统，默认打开shopify运营的任一页面
      if (to.query.random && to.query.systemCode) {
        let findMenu = findPane(store.getters.menus, {
          lastMenu: 2,
          systemCode: to.query.systemCode
        })
        if (!findMenu) {
          findMenu = findPane(store.getters.menus, {
            lastMenu: 2,
            systemCode: 'ORDER_MANAGER'
          })
        }
        if (findMenu) {
          return next(findMenu.path)
        }
      }
      // 去子系统home
      if (to.fullPath !== homePath && typeof homePath === 'string') {
        setCHildAppInfo(to.params.name, store.getters.microApps)
        next(homePath)
      } else {
        setCHildAppInfo(to.params.name, store.getters.microApps)
        next()
      }
    } else {
      setCHildAppInfo(to.params.name, store.getters.microApps)
      next()
    }
  } else {
    store.dispatch('SetLocalDefaultConfig', {
      systemLeave: false
    })
    setCHildAppInfo(to.params.name, store.getters.microApps)
    next()
  }
})

/**
 * @description 神策设置当前子应用编码
 * @param name 当前子应用编码名(scm-web)
 * @param microApps 所有子应用信息集合
*/
const setCHildAppInfo = (name, microApps) => {
  try {
    let childAppCode = {}
    if (name) {
      const childApp = microApps.find(item => item.name === name)
      childAppCode = { name: childApp.name, code: childApp.systemCode }
    }
    Vue.$Shence.setChildAppCode(childAppCode)
  } catch (e) {
    console.warn(e)
  }
}

router.afterEach((to, from) => {
  if (to.name === 'Iframe') {
    // erp1.0页面代理上报路由事件
    try {
      const serviceId = to.params.serviceId + to.params.systemCode
      const { microApps } = store.getters
      const panes = store.getters?.panes?.length ? store.getters.panes : (Vue.ls.get(PANES_HISTORY_CACHE)?.[serviceId] || [])
      const menuId = to.hash.replace(/\D/g, '')
      const findPane = panes.find(item => `${item.menuId || ''}` === menuId)
      const foundSytemCode = microApps.find(app => app.entry === findPane?.systemDomain)?.systemCode
      if (['ORDER_MANAGER', 'WMS_MANAGER'].includes(foundSytemCode)) {
        console.log('iframe:track', findPane, foundSytemCode)
        const { menuName, key, tab } = findPane
        const params = {
          ele_ty: 'menu',
          ele_na: menuName.zh_CN || tab,
          mu_ty: 1,
          p_na: menuName.zh_CN,
          cu_link: `/${key}`,
          ap_sou: foundSytemCode,
          ap_na: foundSytemCode === 'ORDER_MANAGER' ? '订单管理系统' : '仓配管理系统'
        }
        Vue.$Shence.track(params)
      }
      // if (visibleMenus && visibleMenus instanceof Array) {
      //   const findMenuItem = list => {
      //     for (let i = 0; i < list.length; i++) {
      //       if (to.hash === '#/' + list[i].key) {
      //         targetItem = list[i]
      //         return
      //       } else {
      //         if (list[i].childMenus && list[i].childMenus.length) {
      //           findMenuItem(list[i].childMenus)
      //         }
      //       }
      //     }
      //   }
      //   findMenuItem(store.getters.visibleMenus)
      //   if (targetItem && targetItem.systemCode && ['ORDER_MANAGER', 'WMS_MANAGER'].includes(targetItem.systemCode)) {
      //     const { menuName, key, systemCode } = targetItem
      //     const params = {
      //       ele_ty: 'menu',
      //       ele_na: menuName.zh_CN,
      //       mu_ty: 1,
      //       p_na: menuName.zh_CN,
      //       cu_link: `/${key}`,
      //       ap_sou: systemCode,
      //       ap_na: systemCode === 'ORDER_MANAGER' ? '订单管理系统' : '仓配管理系统'
      //     }
      //     Vue.$Shence.track(params)
      //   }
      // }
    } catch (e) {
      console.warn(e)
    }
  }
  NProgress.done()
  document.body.removeChild(firstEle)
})
